import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-filter-signal-strength",
  "use": "icon-filter-signal-strength-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"none\" id=\"icon-filter-signal-strength\">\n  <path d=\"M3 13.3V10.3M6.33 13.3V7.8M9.66 13.3V5.3M13 13.3V2.7\" stroke=\"currentColor\" stroke-width=\"1.6\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol